import React from "react";

const summary = <p>A short fantasy/comedy about an unemployed man who ends up being stuck inside a laptop after he falls in love with video games. 2012</p>;

export default summary;